import React from 'react'
import threeCourses from './../assets/pdf/threeCourses.pdf'
import streetFood from './../assets/pdf/streetFood.pdf'
import canapes from './../assets/pdf/canapes.pdf'
import threeCourseSplitter from './../assets/images/Splitters/threeCourseSplitter.webp'
import streetFoodSplitter from './../assets/images/Splitters/streetFoodSplitter.webp'
import canapesSplitter from './../assets/images/Splitters/canapesSplitter.webp'

const WeddingFiles = () => {

    const files = [
        {
            id: 1,
            title: '3 COURSES',
            href: threeCourses,
            splitter: threeCourseSplitter,
            description:
                'A beautifully curated three-course wedding meal, featuring a selection of expertly crafted dishes made from the finest ingredients, ensuring a memorable dining experience.',
        },
        {
            id: 2,
            title: 'STREET FOOD',
            href: streetFood,
            splitter: streetFoodSplitter,
            description:
                'Add a fun and relaxed touch to your celebration with our vibrant street food menu, offering a delicious array of globally inspired flavors served fresh and tailored to your tastes.',
        },
        {
          id: 3,
          title: 'CANAPES',
          href: canapes,
          splitter: canapesSplitter,
          description:
              'Elevate your wedding reception with our exquisite selection of handcrafted canapés, perfect for welcoming your guests with bite-sized delights that are as elegant as they are delicious.',
      }
      ]

  return (
    <div className="relative z-10">
        <div className="mx-auto max-w-7xl px-6 lg:px-8 bg-[#F7E7CE] bg-opacity-90 backdrop-blur-md py-8 rounded-xl shadow-lg">
          <div className="mx-auto max-w-2xl text-center">
            <h2 className="text-4xl font-semibold tracking-widest text-pretty text-gray-900 sm:text-5xl">MENUS</h2>
            <p className="mt-2 text-lg/8 text-gray-600 tracking-widest">3 COURSES / STREET FOOD / CANAPES</p>
          </div>
          <div className="mx-auto mt-10 grid max-w-2xl grid-cols-1 gap-x-8 lg:gap-y-16 border-t border-gray-200 lg:mx-0 lg:max-w-none md:grid-cols-3 lg:grid-cols-3">
            {files.map((file) => (
              <article key={file.id} className="flex max-w-xl flex-col items-start justify-between text-center">
                <div className="group relative">
                  <h3 className="mt-3 text-lg/6 font-semibold text-gray-900 group-hover:text-gray-600 tracking-wide">
                    <a href={file.href}>    
                      <span className="absolute inset-0" />
                      {file.title}
                    </a>
                  </h3>
                  <img src={file.splitter} alt='card splitter' className='h-[30%] w-auto mx-auto mt-2'/>
                  <p className="mt-5 line-clamp-3 text-sm/6 text-gray-600">{file.description}</p>
                  <a href={file.href} className='text-black ring-1 ring-black ring-inset hover:ring-sky-800 focus-visible:outline-sky-900
                              mt-8 block rounded-md px-3.5 py-2.5 text-center text-sm font-semibold focus-visible:outline-2 focus-visible:outline-offset-2 sm:mt-10'>
                          View Menu
                  </a>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
  )
}

export default WeddingFiles